

import * as tx from './strings';


export const IMG_GENERIC_PRODUCT = {
	src: '/img/product/noimage.jpg',
	alt: tx.TX_ALT_PRODUCT_IMAGE,
}